// eslint-disable-next-line no-restricted-imports
import fetchWrapper from 'js/common/services/api/fetchWrapper';
import { IngestionPipeline, IngestionPipelineRun } from 'js/project/nds/pipelines/pipelineTypes';
import { PolicyItem } from 'js/project/nds/backup/components/backupJobTypes';

function fetchIngestionPipelines(groupId: string): Promise<Array<IngestionPipeline>> {
  return fetchWrapper(`/nds/dls/${groupId}/pipelines`, {
    method: 'GET',
  }).then((resp) => resp.json());
}

function createIngestionPipeline(groupId: string, ingestionPipeline: IngestionPipeline): Promise<IngestionPipeline> {
  return fetchWrapper(`/nds/dls/${groupId}/pipelines`, {
    method: 'POST',
    body: JSON.stringify(ingestionPipeline),
  }).then((resp) => resp.json());
}

function patchIngestionPipeline(groupId: string, ingestionPipeline: IngestionPipeline): Promise<IngestionPipeline> {
  return fetchWrapper(`/nds/dls/${groupId}/pipelines/${ingestionPipeline.name}`, {
    method: 'PATCH',
    body: JSON.stringify(ingestionPipeline),
  }).then((resp) => resp.json());
}

function deleteIngestionPipeline(groupId: string, pipelineName: string): Promise<string> {
  return fetchWrapper(`/nds/dls/${groupId}/pipelines/${pipelineName}`, {
    method: 'DELETE',
  }).then(() => pipelineName);
}

function fetchIngestionPipelineRuns(pipeline: IngestionPipeline): Promise<Array<IngestionPipelineRun>> {
  return fetchWrapper(`/nds/dls/${pipeline.groupId}/pipelines/${pipeline.name}/pipelineRuns`, {
    method: 'GET',
  }).then((resp) => resp.json());
}

function deleteIngestionPipelineRunDataSet(
  groupId: string,
  pipelineName: string,
  pipelineRunId: string
): Promise<IngestionPipelineRun> {
  return fetchWrapper(`/nds/dls/${groupId}/pipelines/${pipelineName}/pipelineRuns/${pipelineRunId}`, {
    method: 'DELETE',
  }).then((resp) => resp.json());
}

function fetchBackupPolicyItemsForGroup(groupId: string): Promise<Record<string, Array<PolicyItem>>> {
  return fetchWrapper(`/nds/dls/${groupId}/backupPolicyItems`, {
    method: 'GET',
  }).then((resp) => resp.json());
}

export {
  fetchIngestionPipelines,
  createIngestionPipeline,
  patchIngestionPipeline,
  deleteIngestionPipeline,
  fetchIngestionPipelineRuns,
  deleteIngestionPipelineRunDataSet,
  fetchBackupPolicyItemsForGroup,
};
